const Product = () => import(/* webpackChunkName: "public-module" */ '@views/Product');

export default [
    {
        path: '/product/:token',
        name: 'product.show-by-token',
        component: Product,
    },
];
